module.exports = "/images/measure-line-top-left-bottom-right.svg?2e88d9e882c1f99c81a726d232f1c33d";